import React, { useState } from "react";
import Table from "./Table";
import Modal from "./Modal";

function App() {
  const [data, setData] = useState([
    { id: 1, title: "", author: "", genre: "" },
    { id: 2, title: "", author: "", genre: "" },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddData = (newItem) => {
    const newData = {
      id: Date.now(),
      ...newItem,
    };
    setData([...data, newData]);
  };

  const handleDelete = (id) => {
    const updatedData = data.filter((item) => item.id !== id);
    setData(updatedData);
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}> Library Book Management</h1>

      <button style={addButtonStyle} onClick={() => setIsModalOpen(true)}>
         Add New Book
      </button>

      {}
      <Table data={data} onDelete={handleDelete} />

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAddData={handleAddData}
      />
    </div>
  );
}

const containerStyle = {
  padding: "50px",
  textAlign: "center",
  backgroundColor: "#fff0f6", 
  minHeight: "100vh",
};

const titleStyle = {
  color: "#6a4c93", 
  fontWeight: "800",
};

const addButtonStyle = {
  backgroundColor: "#ffb3c6", 
  color: "#5a3e36",
  padding: "10px 18px",
  border: "1px solid #000000",
  borderRadius: "20px",
  cursor: "pointer",
  fontWeight: "500",
  marginBottom: "25px",
};

export default App;